import AccountingSummary from '../features/accounting/AccountingSummary';

export default function AccountingSummaryPage() {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Muhasebe Özeti</h1>
          <p>Gelir, gider ve kâr/zarar durumunu dönem bazında inceleyin.</p>
        </div>
      </header>
      <section className="page-section">
        <AccountingSummary />
      </section>
    </div>
  );
}
